export enum NotificationType {
  Alert = "Alert",
  Standard = "Standard",
}

export interface Notification {
  id: number;
  type: NotificationType;
  title: string;
  description: string;
  message?: string | null;
  isParent: boolean;
}
